const evacuation_var1 = JSON.parse(`{
  "module_id": "A/C EVAC",
  "module_var": "1",
  "module_name": "Aircraft Evacuation Smoke Variation",
  "user_id": "xxx@xxx.ch",
  "execution_id": "abcdedf",
  "timestamp_utc_start": "2026-01-16T12:00:00Z",
  "timestamp_utc_end": null,
  "procedure_steps": [
    {
      "step_id": "1",
      "step_name": "Orders from flight deck",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:00",
      "step_detection_timestamp_video_end": "0:30",
      "observable_behaviors": []
    },
    {
      "step_id": "2",
      "step_name": "Outside condition check",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:31",
      "step_detection_timestamp_video_end": "0:45",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Outside conditions checked after \\"Attention Crew! At stations!\\"",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Outside conditions checked after \\"Attention Crew! At stations!\\"",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "4",
      "step_name": "Urgency call to flight deck",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:46",
      "step_detection_timestamp_video_end": "1:00",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Smoke reported to F/D",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "3.10",
          "ob_dashboardname": "Smoke reported to F/D",
          "ob_description": "Identifies deviations and safety hazards and applies effective intervention strategies",
          "ob_adapted_description": "Identifies deviations and safety hazards relating to passengers and the aircraft and applies effective intervention strategies",
          "ob_detected": false
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Interphone operated",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP, interphone system and loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Urgency call used to report smoke",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Mentioning assigned emergency station \\"one left\\"",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with the flight deck and passengers",
          "ob_detected": true
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Smoke in cabin noticed",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "5",
      "step_name": "Smoke in cabin",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:02",
      "step_detection_timestamp_video_end": "1:08",
      "observable_behaviors": [
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Smoke reported to F/D using clear speech/words",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with the flight deck and passengers",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "6",
      "step_name": "Passenger interruption",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:09",
      "step_detection_timestamp_video_end": "1:30",
      "observable_behaviors": [
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to go back to their seat",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with the flight deck and passengers",
          "ob_detected": false
        },
        {
          "ob_id": "3.10",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to go back to their seat",
          "ob_description": "Identifies deviations and safety hazards and applies effective intervention strategies",
          "ob_adapted_description": "Identifies deviations and safety hazards relating to passengers and the aircraft and applies effective intervention strategies",
          "ob_detected": false
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to go back to their seat",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": true
        },
        {
          "ob_id": "5.6",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to go back to their seat",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": false
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Assertive decision relating to passenger communicated in a timely manner",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": true
        },
        {
          "ob_id": "5.6",
          "ob_dashboardname": "Assertive decision relating to passenger communicated in a timely manner",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "7",
      "step_name": "Flight deck initiates evacuation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:31",
      "step_detection_timestamp_video_end": "1:35",
      "observable_behaviors": []
    },
    {
      "step_id": "8",
      "step_name": "Trainee shouts initial orders",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:36",
      "step_detection_timestamp_video_end": "1:42",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Initial orders/instructions to passengers",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Initial orders/instructions to passengers",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with the flight deck and passengers",
          "ob_detected": false
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Initial orders/instructions to passengers",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "Correct initial evacuation orders",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Correct initial evacuation orders",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "2.9",
          "ob_dashboardname": "Correct initial evacuation orders",
          "ob_description": "Adheres to standard operator phraseology and procedures",
          "ob_adapted_description": "Adheres to standard phraseology relating to orders",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "9",
      "step_name": "EMER lights",
      "step_detected": false,
      "step_detection_timestamp_video_start": null,
      "step_detection_timestamp_video_end": null,
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Button EMER light pressed",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Button EMER light pressed",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP, interphone system and loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Button EMER light pressed",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "10",
      "step_name": "Door operation / Grab frame assist handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:47",
      "step_detection_timestamp_video_end": "1:52",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Secured at frame assist handle",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Secured at frame assist handle until slide fully inflated",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "11",
      "step_name": "Slide arming lever in ARMED position",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:53",
      "step_detection_timestamp_video_end": "1:55",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Slide aming lever checked",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Slide aming lever checked",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "12",
      "step_name": "Check outside condition (no fire, just tarmac, no special condition)",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:56",
      "step_detection_timestamp_video_end": "1:59",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Outside conditions checked before opening door",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Outside conditions checked before opening door",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "13",
      "step_name": "Raise door control handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:00",
      "step_detection_timestamp_video_end": "2:01",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Door handle operated",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Door handle operated",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP, interphone system and loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Door handle operated",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "14",
      "step_name": "No slide inflation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:02",
      "step_detection_timestamp_video_end": "2:04",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Slide inflation checked (no inflation)",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Slide inflation checked (no inflation)",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Slide inflation checked (no inflation)",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "15",
      "step_name": "Manual inflation handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:05",
      "step_detection_timestamp_video_end": "2:07",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP, interphone system and loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "5.6",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": true
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "16",
      "step_name": "Check slide inflation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:08",
      "step_detection_timestamp_video_end": "2:10",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Slide inflation checked",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Slide inflation checked",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Slide inflation checked",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "17",
      "step_name": "Evacuation orders at station",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:11",
      "step_detection_timestamp_video_end": "2:14",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Orders/instructions to passengers to leave aircraft",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Correct evacuation orders at station",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Orders/instructions to passengers to leave aircraft",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": true
        },
        {
          "ob_id": "2.9",
          "ob_dashboardname": "Correct evacuation orders at station",
          "ob_description": "Adheres to standard operator phraseology and procedures",
          "ob_adapted_description": "Adheres to standard phraseology relating to orders",
          "ob_detected": true
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Orders/instructions to passengers to leave aircraft",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with the flight deck and passengers",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "Correct evacuation orders at station",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "18",
      "step_name": "Check for remaining passengers",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:16",
      "step_detection_timestamp_video_end": "2:46",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Cabin checked for remaining passengers",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Cabin checked for remaining passengers",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "19",
      "step_name": "Emergency equipment",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:47",
      "step_detection_timestamp_video_end": "3:15",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Emergency equipment collected (at least one item)",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Emergency equipment collected (all assigned items)",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "20",
      "step_name": "Crowd control",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:16",
      "step_detection_timestamp_video_end": "3:35",
      "observable_behaviors": [
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Correct use of megaphone",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP, interphone system and loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Instructions to passengers on tarmac",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with the flight deck and passengers",
          "ob_detected": false
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": true
        },
        {
          "ob_id": "4.4",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Informs and monitors passengers for compliance with regulations",
          "ob_adapted_description": "Effectively performs crowd control after evacuation on tarmac",
          "ob_detected": false
        }
      ]
    }
  ]
}`);

const evacuation_var2 = JSON.parse(`{
  "module_id": "A/C EVAC",
  "module_var": "2",
  "module_name": "Aircraft Evacuation Two Door Variation",
  "user_id": "xxx@xxx.ch",
  "execution_id": "abcdedf",
  "timestamp_utc_start": "2026-01-17T12:00:00Z",
  "timestamp_utc_end": null,
  "procedure_steps": [
    {
      "step_id": "1",
      "step_name": "Orders from flight deck",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:01",
      "step_detection_timestamp_video_end": "0:06",
      "observable_behaviors": []
    },
    {
      "step_id": "2",
      "step_name": "Check outside condition",
      "step_detected": false,
      "step_detection_timestamp_video_start": null,
      "step_detection_timestamp_video_end": null,
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Outside conditions checked after \\"Attention Crew! At stations!\\"",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1L AND 1R: outside conditions checked after \\"Attention Crew! At stations!\\"",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "3",
      "step_name": "Flight deck initiated evacuation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:16",
      "step_detection_timestamp_video_end": "0:23",
      "observable_behaviors": []
    },
    {
      "step_id": "4",
      "step_name": "CCM shouts initial orders",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:23",
      "step_detection_timestamp_video_end": "0:34",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Initial orders/instructions to passengers",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Initial orders/instructions to passengers",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
          "ob_detected": false
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Initial orders/instructions to passengers",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "Correct initial evacuation orders",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Correct initial evacuation orders",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "2.9",
          "ob_dashboardname": "Correct initial evacuation orders",
          "ob_description": "Adheres to standard operator phraseology and procedures",
          "ob_adapted_description": "Adheres to standard phraseology relating to orders",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "5",
      "step_name": "EMER lights",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:35",
      "step_detection_timestamp_video_end": "0:43",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Button EMER light pressed",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Button EMER light pressed",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP: EMER light, loose emergency equipment",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Button EMER light pressed",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "6",
      "step_name": "Door operation 1L / Grab frame assist handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:45",
      "step_detection_timestamp_video_end": "0:57",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Secured at frame assist handle",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Secured at frame assist handle until slide fully inflated",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "7",
      "step_name": "Slide arming lever in ARMED position",
      "step_detected": true,
      "step_detection_timestamp_video_start": "0:57",
      "step_detection_timestamp_video_end": "1:06",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Slide aming lever checked",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Slide aming lever checked",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "8",
      "step_name": "Check outside condition (no fire)",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:06",
      "step_detection_timestamp_video_end": "1:13",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Outside conditions checked before opening door",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Outside conditions checked before opening door",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "9",
      "step_name": "Raise door control handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:13",
      "step_detection_timestamp_video_end": "1:22",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Door handle operated",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Door handle operated",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP: EMER light, loose emergency equipment",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Door handle operated",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "10",
      "step_name": "Failure of pneumatic door opening",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:23",
      "step_detection_timestamp_video_end": "1:31",
      "observable_behaviors": [
        {
          "ob_id": "5.6",
          "ob_dashboardname": "Door pushed manually",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "11",
      "step_name": "ABP",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:31",
      "step_detection_timestamp_video_end": "1:38",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "ABP called",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "ABP called",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "5.6",
          "ob_dashboardname": "ABP called",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": false
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "ABP called",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "ABP called",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "12",
      "step_name": "Push door open",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:40",
      "step_detection_timestamp_video_end": "1:49",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Door opened with ABP",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Door opened with ABP",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP: EMER light, loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Door opened with ABP",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "5.6",
          "ob_dashboardname": "Door opened with ABP",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "13",
      "step_name": "Hold back ABP until slide inflated",
      "step_detected": true,
      "step_detection_timestamp_video_start": "1:49",
      "step_detection_timestamp_video_end": "2:00",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Slide inflation checked (no inflation)",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Slide inflation checked (no inflation)",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Slide inflation checked (no inflation)",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "ABP instructed to wait",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "14",
      "step_name": "Manual inflation handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:01",
      "step_detection_timestamp_video_end": "2:12",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP: EMER light, loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "5.6",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Applies appropriate and timely decision-making techniques",
          "ob_adapted_description": "Applies appropriate and timely decision-making techniques concerning passengers and aircraft systems during an evacuation",
          "ob_detected": true
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "Manual inflation handle pulled (in a timely manner)",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "15",
      "step_name": "Check slide inflation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:12",
      "step_detection_timestamp_video_end": "2:20",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Slide inflation checked",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Slide inflation checked",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Slide inflation checked",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "16",
      "step_name": "Begin evacuation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:20",
      "step_detection_timestamp_video_end": "2:27",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Orders/instructions to passengers to leave aircraft",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Correct evacuation orders at station",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Orders/instructions to passengers to leave aircraft",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
          "ob_detected": false
        },
        {
          "ob_id": "2.9",
          "ob_dashboardname": "Correct evacuation orders at station",
          "ob_description": "Adheres to standard operator phraseology and procedures",
          "ob_adapted_description": "Adheres to standard phraseology relating to orders",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "Correct evacuation orders at station",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "17",
      "step_name": "Passenger interruption",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:29",
      "step_detection_timestamp_video_end": "2:41",
      "observable_behaviors": [
        {
          "ob_id": "3.10",
          "ob_dashboardname": "Passenger getting hand luggage noticed",
          "ob_description": "Identifies deviations and safety hazards and applies effective intervention strategies",
          "ob_adapted_description": "Identifies aisle-blocking-passenger as a hazard and handles situation effectively",
          "ob_detected": false
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "Passenger getting hand luggage noticed",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        },
        {
          "ob_id": "6.4",
          "ob_dashboardname": "Passenger getting hand luggage noticed",
          "ob_description": "Maintains awareness of the people involved in or affected by the operation and their capacity to perform as expected",
          "ob_adapted_description": "Notices abnormalities in the passenger flow during the evacuation",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "18",
      "step_name": "Instruct pax",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:43",
      "step_detection_timestamp_video_end": "2:51",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to leave hand luggage behind",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to leave hand luggage behind",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to leave hand luggage behind",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
          "ob_detected": true
        },
        {
          "ob_id": "3.10",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to leave hand luggage behind",
          "ob_description": "Identifies deviations and safety hazards and applies effective intervention strategies",
          "ob_adapted_description": "Identifies aisle-blocking-passenger as a hazard and handles situation effectively",
          "ob_detected": true
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to leave hand luggage behind",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": false
        },
        {
          "ob_id": "4.4",
          "ob_dashboardname": "Clear/assertive speech when instructing passenger to leave hand luggage behind",
          "ob_description": "Informs and monitors passengers for compliance with regulations",
          "ob_adapted_description": "Effectively performs crowd control after evacuation on tarmac",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "19",
      "step_name": "Door operation 1R / Grab frame assist handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "2:53",
      "step_detection_timestamp_video_end": "3:03",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "1R: secured at frame assist handle",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1R: secured at frame assist handle until slide fully inflated",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "20",
      "step_name": "Slide arming lever in ARMED position",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:05",
      "step_detection_timestamp_video_end": "3:15",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "1R: slide aming lever checked",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1R: slide aming lever checked",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "21",
      "step_name": "Check outside condition (no fire)",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:16",
      "step_detection_timestamp_video_end": "3:23",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "1R: outside conditions checked before opening door",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1R: outside conditions checked before opening door",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        }
      ]
    },
    {
      "step_id": "22",
      "step_name": "Raise door control handle",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:23",
      "step_detection_timestamp_video_end": "3:35",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "1R: door handle operated",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.4",
          "ob_dashboardname": "1R: door handle operated",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP: EMER light, loose emergency equipment",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1R: door handle operated",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "1R: door handle operated",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        },
        {
          "ob_id": "7.1",
          "ob_dashboardname": "1R: door handle operated",
          "ob_description": "Manages time efficiently when carrying out tasks",
          "ob_adapted_description": "Opens both doors 1L and 1R (no specific order required) in a timely manner",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "23",
      "step_name": "Check slide inflation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:36",
      "step_detection_timestamp_video_end": "3:41",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "1R: Slide inflation checked",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1R: Slide inflation checked",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "6.2",
          "ob_dashboardname": "1R: Slide inflation checked",
          "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
          "ob_adapted_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems noticing abnormalities",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "24",
      "step_name": "Begin evacuation",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:41",
      "step_detection_timestamp_video_end": "3:46",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "1R: Orders/instructions to passengers",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "1R: Correct evacuation orders at station",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": true
        },
        {
          "ob_id": "2.9",
          "ob_dashboardname": "1R: Correct evacuation orders at station",
          "ob_description": "Adheres to standard operator phraseology and procedures",
          "ob_adapted_description": "Adheres to standard phraseology relating to orders",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "1R: Orders/instructions to passengers",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
          "ob_detected": false
        },
        {
          "ob_id": "7.8",
          "ob_dashboardname": "1R: Correct evacuation orders at station",
          "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
          "ob_adapted_description": "Manages and recovers from interruptions, distractions, variations and failures in a high-stress environment effectively while performing necessary tasks for an evacuation",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "25",
      "step_name": "Check for remaining passengers",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:46",
      "step_detection_timestamp_video_end": "3:52",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Cabin checked for remaining passengers",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Cabin checked for remaining passengers",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "26",
      "step_name": "Emergency equipment",
      "step_detected": true,
      "step_detection_timestamp_video_start": "3:54",
      "step_detection_timestamp_video_end": "4:04",
      "observable_behaviors": [
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Emergency equipment collected (at least one item)",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": true
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Emergency equipment collected (all assigned items)",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        }
      ]
    },
    {
      "step_id": "27",
      "step_name": "Crowd control",
      "step_detected": true,
      "step_detection_timestamp_video_start": "4:06",
      "step_detection_timestamp_video_end": "4:11",
      "observable_behaviors": [
        {
          "ob_id": "1.4",
          "ob_dashboardname": "Correct use of megaphone",
          "ob_description": "Operates cabin systems and equipment",
          "ob_adapted_description": "Correctly operates door, slide, FAP: EMER light, loose emergency equipment",
          "ob_detected": false
        },
        {
          "ob_id": "1.2",
          "ob_dashboardname": "Instructions to passengers on tarmac",
          "ob_description": "Applies relevant policies and procedures",
          "ob_adapted_description": "Applies the correct procedure for an emergency evacuation land",
          "ob_detected": false
        },
        {
          "ob_id": "1.5",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Complies with applicable policies and procedures",
          "ob_adapted_description": "Correctly executes the procedure for an emergency evacuation land including interruptions",
          "ob_detected": false
        },
        {
          "ob_id": "2.3",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
          "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
          "ob_detected": false
        },
        {
          "ob_id": "4.1",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
          "ob_adapted_description": "Assertively informs passengers to follow instructions",
          "ob_detected": false
        },
        {
          "ob_id": "4.4",
          "ob_dashboardname": "Clear, assertive crowd control on tarmac",
          "ob_description": "Informs and monitors passengers for compliance with regulations",
          "ob_adapted_description": "Effectively performs crowd control after evacuation on tarmac",
          "ob_detected": true
        }
      ]
    }
  ]
}`);


// NEW PROCEDURES 20260321
const emergency_mode_ditching_var2 = {
    "module_id": "DNEO",
    "module_var": "2",
    "module_name": "Emergency Mode - Land",
    "user_id": "xxx@xxx.ch",
    "execution_id": "abcdedf",
    "timestamp_utc_start": "2026-03-17T12:00:00Z",
    "timestamp_utc_end": null,
    "procedure_steps": [
        {
            "step_id": "2",
            "step_name": "Initial evacuation orders",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:00",
            "step_detection_timestamp_video_end": "0:05",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Initial orders/instructions to passengers",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": true,
                },
                {
                    "ob_id": "2.3",
                    "ob_dashboardname": "Initial orders/instructions to passengers",
                    "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
                    "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Correct initial evacuation orders",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": false,
                },
                {
                    "ob_id": "2.9",
                    "ob_dashboardname": "Correct initial evacuation orders",
                    "ob_description": "Adheres to standard phraseology and procedures",
                    "ob_adapted_description": "Adheres to standard phraseology relating to orders",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "3",
            "step_name": "Grasp Frame Assist Handle",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Secured at frame assist handle",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Secured at frame assist handle until slide fully inflated",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "4",
            "step_name": "Check Lever ARMED",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:06",
            "step_detection_timestamp_video_end": "0:08",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Slide arming lever checked",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Slide arming lever checked",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "5",
            "step_name": "Check Outside Condition (Land)",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:09",
            "step_detection_timestamp_video_end": "0:11",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Outside conditions checked",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Outside conditions checked",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "6",
            "step_name": "Open Door (Pneumatic)",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:12",
            "step_detection_timestamp_video_end": "0:14",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door handle operated",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door handle operated",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the door in an emergency situation",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door handle operated",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "7",
            "step_name": "Check Slide Auto Inflation",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Slide inflation checked",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Slide inflation checked",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "8",
            "step_name": "Evacuation orders at station",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:15",
            "step_detection_timestamp_video_end": "0:18",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Orders/instructions to passengers",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning emergency door operation land",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Correct evacuation orders at station",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for an evacuation land",
                    "ob_detected": false,
                },
                {
                    "ob_id": "2.9",
                    "ob_dashboardname": "Correct evacuation orders at station",
                    "ob_description": "Adheres to standard phraseology and procedures",
                    "ob_adapted_description": "Adheres to standard phraseology relating to orders",
                    "ob_detected": false,
                },
                {
                    "ob_id": "2.3",
                    "ob_dashboardname": "Orders/instructions to passengers",
                    "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
                    "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
                    "ob_detected": true,
                }
            ],
        }
    ],
}

const normal_access_code_with_interruption = {
    "module_id": "FDAP",
    "module_var": "2",
    "module_name": "Normal Access Code With Interruption",
    "user_id": "xxx@xxx.ch",
    "execution_id": "abcdedf",
    "timestamp_utc_start": "2026-03-17T12:00:00Z",
    "timestamp_utc_end": null,
    "procedure_steps": [
        {
            "step_id": "A2",
            "step_name": "Area Check",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:00",
            "step_detection_timestamp_video_end": "0:10",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Area check, left OR right side of galley",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Area check, left AND right side of galley",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "A4",
            "step_name": "Curtain Check",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:11",
            "step_detection_timestamp_video_end": "0:19",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Curtain (partially) closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Curtain (partially) closed",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Curtain fully closed",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "A5",
            "step_name": "Grab Coffee",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:20",
            "step_detection_timestamp_video_end": "0:25",
            "observable_behaviors": [],
        },
        {
            "step_id": "A5.1",
            "step_name": "Passenger Interruption",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:26",
            "step_detection_timestamp_video_end": "0:40",
            "observable_behaviors": [
                {
                    "ob_id": "6.1",
                    "ob_dashboardname": "Passenger noticed",
                    "ob_description": "Monitors and assesses passenger and crew behaviour",
                    "ob_adapted_description": "Awareness for passenger interruption when entering the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "4.4",
                    "ob_dashboardname": "Passenger interruption prioritised/handled",
                    "ob_description": "Informs and monitors passengers for compliance with regulations",
                    "ob_adapted_description": "Informs passenger to comply with regulations by instructing or assisting them",
                    "ob_detected": false,
                },
                {
                    "ob_id": "5.6",
                    "ob_dashboardname": "Passenger interruption prioritised/handled",
                    "ob_description": "Applies appropriate and timely decision-making techniques",
                    "ob_adapted_description": "Applies appropriate and timely decision-making techniques by instructing or assisting the passenger",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A5.2",
            "step_name": "Re-secure Curtain",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Curtain (partially) re-closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Curtain (partially) re-closed",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Curtain fully re-closed",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A6.1",
            "step_name": "Flight Deck Access Panel",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:47",
            "step_detection_timestamp_video_end": "0:57",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Correct code entered on keypad",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Correct code entered on keypad",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Code entered on keypad",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Look into camera",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Look into camera",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "A7",
            "step_name": "Flight Deck Access via Door",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:58",
            "step_detection_timestamp_video_end": "1:05",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door opened",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door opened",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door opened",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "A8",
            "step_name": "Closing the Door via Flight Deck",
            "step_detected": true,
            "step_detection_timestamp_video_start": "1:06",
            "step_detection_timestamp_video_end": "1:11",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door closed in a timely manner",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A9",
            "step_name": "Coffee Hand-Over",
            "step_detected": true,
            "step_detection_timestamp_video_start": "1:12",
            "step_detection_timestamp_video_end": "1:18",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Coffee handed over via commander's left shoulder",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Coffee handed over via commander's left shoulder",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A10",
            "step_name": "Request Camera",
            "step_detected": true,
            "step_detection_timestamp_video_start": "1:19",
            "step_detection_timestamp_video_end": "1:30",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Camera checked before exiting",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Camera checked before exiting",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A11",
            "step_name": "Leave flight deck",
            "step_detected": true,
            "step_detection_timestamp_video_start": "1:31",
            "step_detection_timestamp_video_end": "1:36",
            "observable_behaviors": [
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door openend",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door closed in a timely manner",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        }
    ],
}

const normal_access_code_without_interruption = {
    "module_id": "FDAP",
    "module_var": "1",
    "module_name": "Normal Access Code Without Interruption",
    "user_id": "xxx@xxx.ch",
    "execution_id": "abcdedf",
    "timestamp_utc_start": "2026-03-17T12:00:00Z",
    "timestamp_utc_end": null,
    "procedure_steps": [
        {
            "step_id": "A2",
            "step_name": "Area Check",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:00",
            "step_detection_timestamp_video_end": "0:10",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Area check, left OR right side of galley",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Area check, left AND right side of galley",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "A4",
            "step_name": "Curtain Check",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:11",
            "step_detection_timestamp_video_end": "0:20",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Curtain (partially) closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Curtain (partially) closed",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Curtain fully closed",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A5",
            "step_name": "Grab Coffee",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:21",
            "step_detection_timestamp_video_end": "0:24",
            "observable_behaviors": [],
        },
        {
            "step_id": "A6.1",
            "step_name": "Flight Deck Access Panel",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:25",
            "step_detection_timestamp_video_end": "0:33",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Correct code entered on keypad",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Correct code entered on keypad",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Code entered on keypad",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Look into camera",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Look into camera",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A7",
            "step_name": "Flight Deck Access via Door",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:34",
            "step_detection_timestamp_video_end": "0:40",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door opened",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door opened",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door opened",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "A8",
            "step_name": "Closing the Door via Flight Deck",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:41",
            "step_detection_timestamp_video_end": "0:44",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door closed in a timely manner",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A9",
            "step_name": "Coffee Hand-Over",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Coffee handed over via commander's left shoulder",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Coffee handed over via commander's left shoulder",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A10",
            "step_name": "Request Camera",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Camera checked before exiting",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Camera checked before exiting",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "A11",
            "step_name": "Leave flight deck",
            "step_detected": true,
            "step_detection_timestamp_video_start": "1:06",
            "step_detection_timestamp_video_end": "1:12",
            "observable_behaviors": [
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door openend",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the cabin systems related to flight deck door access",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door closed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Follows the procedures for implementing the clear zone policy when admitting or exiting the flight deck as well as the handling of liquids in the flight deck",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door closed in a timely manner",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Adheres to the polices laid down in the operator manual and ensures appropriate implementation of 1.2",
                    "ob_detected": false,
                }
            ],
        }
    ],
}

const emergency_mode_ditching_var31 = {
    "module_id": "DNEO",
    "module_var": "3.1",
    "module_name": "Emergency Mode - Ditching",
    "user_id": "xxx@xxx.ch",
    "execution_id": "abcdedf",
    "timestamp_utc_start": "2026-03-17T12:00:00Z",
    "timestamp_utc_end": null,
    "procedure_steps": [
        {
            "step_id": "E2",
            "step_name": "Initial evacuation orders",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:00",
            "step_detection_timestamp_video_end": "0:05",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Initial orders/instructions to passengers",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": false,
                },
                {
                    "ob_id": "2.3",
                    "ob_dashboardname": "Initial orders/instructions to passengers",
                    "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
                    "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
                    "ob_detected": false,
                },
                {
                    "ob_id": "4.1",
                    "ob_dashboardname": "Initial orders/instructions to passengers",
                    "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
                    "ob_adapted_description": "Assertively informs passengers to follow instructions",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Correct initial evacuation orders",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                },
                {
                    "ob_id": "2.9",
                    "ob_dashboardname": "Correct initial evacuation orders",
                    "ob_description": "Adheres to standard phraseology and procedures",
                    "ob_adapted_description": "Adheres to standard phraseology relating to orders",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "E3",
            "step_name": "Press EMER Light and EVAC CMD (also possible before initial evac orders)",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Button EMER light pressed",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Button EMER light pressed",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the door and cabin systems in a ditching scenario",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Button EMER light pressed",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "E4",
            "step_name": "Grasp Frame Assist Handle",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:12",
            "step_detection_timestamp_video_end": "0:17",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Secured at frame assist handle",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Secured at frame assist handle until slide fully inflated",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "E5",
            "step_name": "Check Lever ARMED",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:18",
            "step_detection_timestamp_video_end": "0:23",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Slide aming lever checked",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Slide aming lever checked",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "E6",
            "step_name": "Check Outside Condition (Water)",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:24",
            "step_detection_timestamp_video_end": "0:29",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Outside conditions checked",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Outside conditions checked",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "E7",
            "step_name": "Open Door (Pneumatic)",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:30",
            "step_detection_timestamp_video_end": "0:35",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door handle operated",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door handle operated",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the door and cabin systems in a ditching scenario",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door handle operated",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "E7a",
            "step_name": "Push Door Manually",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:36",
            "step_detection_timestamp_video_end": "0:41",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Door pushed (in a timely manner)",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Door pushed (in a timely manner)",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the door and cabin systems in a ditching scenario",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Door pushed open all the way in a timely manner",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": false,
                },
                {
                    "ob_id": "5.6",
                    "ob_dashboardname": "Door pushed open all the way in a timely manner",
                    "ob_description": "Applies appropriate and timely decision-making techniques",
                    "ob_adapted_description": "Efficiently handles door malfunctions",
                    "ob_detected": false,
                },
                {
                    "ob_id": "6.2",
                    "ob_dashboardname": "Door pushed open all the way in a timely manner",
                    "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
                    "ob_adapted_description": "Notices door malfunctions",
                    "ob_detected": false,
                },
                {
                    "ob_id": "7.8",
                    "ob_dashboardname": "Door pushed open all the way in a timely manner",
                    "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
                    "ob_adapted_description": "Manages and recovers from door malfunctions",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "E8",
            "step_name": "Check Slide Auto Inflation",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:42",
            "step_detection_timestamp_video_end": "0:47",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Slide inflation checked (no inflation)",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Slide inflation checked (no inflation)",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                },
                {
                    "ob_id": "6.2",
                    "ob_dashboardname": "Slide inflation checked (no inflation)",
                    "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
                    "ob_adapted_description": "Notices door malfunctions",
                    "ob_detected": true,
                }
            ],
        },
        {
            "step_id": "E8a",
            "step_name": "Pull Manual Inflation Handle",
            "step_detected": true,
            "step_detection_timestamp_video_start": "0:48",
            "step_detection_timestamp_video_end": "0:53",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Manual inflation handle pulled",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.4",
                    "ob_dashboardname": "Manual inflation handle pulled",
                    "ob_description": "Operates cabin systems and equipment",
                    "ob_adapted_description": "Correctly operates the door and cabin systems in a ditching scenario",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Manual inflation handle pulled in a timely manner",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": false,
                },
                {
                    "ob_id": "5.6",
                    "ob_dashboardname": "Manual inflation handle pulled in a timely manner",
                    "ob_description": "Applies appropriate and timely decision-making techniques",
                    "ob_adapted_description": "Efficiently handles door malfunctions",
                    "ob_detected": false,
                },
                {
                    "ob_id": "6.2",
                    "ob_dashboardname": "Manual inflation handle pulled in a timely manner",
                    "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
                    "ob_adapted_description": "Notices door malfunctions",
                    "ob_detected": false,
                },
                {
                    "ob_id": "7.8",
                    "ob_dashboardname": "Manual inflation handle pulled in a timely manner",
                    "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
                    "ob_adapted_description": "Manages and recovers from door malfunctions",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "E10",
            "step_name": "Verify Slide Inflated",
            "step_detected": false,
            "step_detection_timestamp_video_start": null,
            "step_detection_timestamp_video_end": null,
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Slide inflation checked",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": false,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Slide inflation checked",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": false,
                },
                {
                    "ob_id": "6.2",
                    "ob_dashboardname": "Slide inflation checked",
                    "ob_description": "Monitors and assesses the general environment, state of the aircraft and cabin systems as these may affect the operation",
                    "ob_adapted_description": "Notices door malfunctions",
                    "ob_detected": false,
                }
            ],
        },
        {
            "step_id": "E11",
            "step_name": "Evacuation Commands",
            "step_detected": true,
            "step_detection_timestamp_video_start": "1:00",
            "step_detection_timestamp_video_end": "1:05",
            "observable_behaviors": [
                {
                    "ob_id": "1.2",
                    "ob_dashboardname": "Orders/instructions to passengers",
                    "ob_description": "Applies relevant policies and procedures",
                    "ob_adapted_description": "Applies relevant policies and procedures concerning ditching scenarios",
                    "ob_detected": true,
                },
                {
                    "ob_id": "1.5",
                    "ob_dashboardname": "Correct evacuation orders at station",
                    "ob_description": "Complies with applicable policies and procedures",
                    "ob_adapted_description": "Complies with policies and procedures relevant for a ditching",
                    "ob_detected": true,
                },
                {
                    "ob_id": "2.9",
                    "ob_dashboardname": "Correct evacuation orders at station",
                    "ob_description": "Adheres to standard phraseology and procedures",
                    "ob_adapted_description": "Adheres to standard phraseology relating to orders",
                    "ob_detected": true,
                },
                {
                    "ob_id": "2.3",
                    "ob_dashboardname": "Orders/instructions to passengers",
                    "ob_description": "Conveys messages clearly, using designated common language (e.g. multilingual flight/cabin crew)",
                    "ob_adapted_description": "Clearly conveys messages in emergency situations when communicating with passengers",
                    "ob_detected": true,
                },
                {
                    "ob_id": "4.1",
                    "ob_dashboardname": "Orders/instructions to passengers",
                    "ob_description": "Exhibits assertiveness when required (e.g. ditching, evacuation, …)",
                    "ob_adapted_description": "Assertively informs passengers to follow instructions",
                    "ob_detected": true,
                },
                {
                    "ob_id": "7.8",
                    "ob_dashboardname": "Correct evacuation orders at station",
                    "ob_description": "Manages and recovers from interruptions, distractions, variations and failures effectively while performing tasks",
                    "ob_adapted_description": "Manages and recovers from door malfunctions",
                    "ob_detected": true,
                }
            ],
        }
    ],
}

export const variations = [
    evacuation_var1,
    evacuation_var2,

    emergency_mode_ditching_var2,
    normal_access_code_with_interruption,
    normal_access_code_without_interruption,
    emergency_mode_ditching_var31,
]

export const getVariationByModuleName = (module_name: string) => {
    const n = module_name.toLowerCase();
    if(n.includes('evacuation') && n.includes('var') && n.includes('1')) {return evacuation_var1;}
    if(n.includes('evacuation') && n.includes('var') && n.includes('2')) {return evacuation_var2;}

    if(n.includes('door') && n.includes('opening') && n.includes('closing') && n.includes('without') && n.includes('interrupt')) {return emergency_mode_ditching_var2;}
    if(n.includes('door') && (n.includes('normal') || n.includes('emergency')) && n.includes('var 2')) {return emergency_mode_ditching_var2;}

    if(n.includes('emergency') && n.includes('mode') && n.includes('ditching') && n.includes('var 3.1')) {return emergency_mode_ditching_var31;}
    if(n.includes('door') && (n.includes('normal') || n.includes('emergency')) && n.includes('var 3.1')) {return emergency_mode_ditching_var31;}

    if(n.includes('normal') && n.includes('access') && n.includes('code') && n.includes('without') && n.includes('interruption')) {return normal_access_code_without_interruption;}
    if(n.includes('flight') && n.includes('deck') && n.includes('access') && n.includes('var 1')) {return normal_access_code_without_interruption;}

    if(n.includes('normal') && n.includes('access') && n.includes('code') && n.includes('with') && n.includes('interruption')) {return normal_access_code_with_interruption;}
    if(n.includes('flight') && n.includes('deck') && n.includes('access') && n.includes('var 2')) {return normal_access_code_with_interruption;}

    return variations.find(v => n.includes(v.module_name));
}